const { ContractNames } = require("../contracts/names");

// Returns the number of markets that have been created
// note: current market number is the next market id to be created
async function bondAggregatorGetMarketsCounter(contracts, contractName) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.marketCounter();
}

async function bondAggregatorGetMarketById(contracts, contractName, id) {
  const aggregator = contracts.getContractByName(contractName);
  const auctioneerAddress = await aggregator.getAuctioneer(id);
  const auctioneerName = contracts.getNameByAddress(auctioneerAddress);
  const auctioneer = contracts.getContractByAddress(auctioneerAddress);

  let marketType;
  let vestingType;

  if (auctioneerName.includes("FPA")) {
    marketType = "FPA";
  } else if (auctioneerName.includes("OFDA")) {
    marketType = "OFDA";
  } else if (auctioneerName.includes("OSDA")) {
    marketType = "OSDA";
  } else if (auctioneerName.includes("SDA")) {
    marketType = "SDA";
  } else if (auctioneerName.includes("FPDA")) {
    marketType = "FPDA";
  } else {
    marketType = "Unknown";
  }

  if (auctioneerName.includes("FixedExpiry")) {
    vestingType = "Fixed-expiry";
  } else if (auctioneerName.includes("FixedTerm")) {
    vestingType = "Fixed-term";
  } else {
    vestingType = "Unknown";
  }

  const baseMarket = await auctioneer.markets(id);
  const marketTerms = await auctioneer.terms(id);
  // Only SDA auctioner has metadata and adjustments
  let marketMetadata = {};
  let marketAdjustments = {};

  if (auctioneerName === ContractNames.FixedExpirySDA || auctioneerName === ContractNames.FixedTermSDA) {
    marketMetadata = await auctioneer.metadata(id);
    marketAdjustments = await auctioneer.adjustments(id);
  }

  return {
    id,
    marketType,
    vestingType,
    ...baseMarket,
    ...marketTerms,
    ...marketMetadata,
    ...marketAdjustments,
  };
}

async function bondAggregatorGetAllLiveMarketsIds(contracts, contractName, fetchMarketSize = 10) {
  const aggregator = contracts.getContractByName(contractName);

  const marketsCount = await aggregator.marketCounter();
  let marketsIds = [];
  let firstIndex = 0;
  let lastIndex = Math.min(fetchMarketSize, marketsCount);
  while (firstIndex < marketsCount) {
    const ids = await aggregator.liveMarketsBetween(firstIndex, lastIndex);
    marketsIds = marketsIds.concat(ids);

    firstIndex += fetchMarketSize;
    lastIndex = Math.min(lastIndex + fetchMarketSize, marketsCount);
  }

  return marketsIds;
}

async function bondAggregatorGetAllLiveMarkets(contracts, contractName, fetchMarketSize = 10) {
  const aggregator = contracts.getContractByName(contractName);

  const marketsCount = await aggregator.marketCounter();
  let marketsIds = [];
  let firstIndex = 0;
  let lastIndex = Math.min(fetchMarketSize, marketsCount);
  while (firstIndex < marketsCount) {
    const ids = await aggregator.liveMarketsBetween(firstIndex, lastIndex);
    marketsIds = marketsIds.concat(ids);

    firstIndex += fetchMarketSize;
    lastIndex = Math.min(lastIndex + fetchMarketSize, marketsCount);
  }

  return await Promise.all(
    marketsIds.map(async (id) => await bondAggregatorGetMarketById(contracts, contractName, id))
  );
}

async function bondAggregatorGetAllClosingMarketsIds(contracts, contractName, fetchMarketSize = 10) {
  const aggregator = contracts.getContractByName(contractName);

  const marketsCount = await aggregator.marketCounter();
  let marketsIds = [];
  let firstIndex = 0;
  let lastIndex = Math.min(fetchMarketSize, marketsCount);
  while (firstIndex < marketsCount) {
    const ids = await aggregator.closingMarketsBetween(firstIndex, lastIndex);
    marketsIds = marketsIds.concat(ids);

    firstIndex += fetchMarketSize;
    lastIndex = Math.min(lastIndex + fetchMarketSize, marketsCount);
  }

  return marketsIds;
}

async function bondAggregatorGetAllClosingMarkets(contracts, contractName, fetchMarketSize = 10) {
  const aggregator = contracts.getContractByName(contractName);

  const marketsCount = await aggregator.marketCounter();
  let marketsIds = [];
  let firstIndex = 0;
  let lastIndex = Math.min(fetchMarketSize, marketsCount);
  while (firstIndex < marketsCount) {
    const ids = await aggregator.liveMarketsBetween(firstIndex, lastIndex);
    marketsIds = marketsIds.concat(ids);

    firstIndex += fetchMarketSize;
    lastIndex = Math.min(lastIndex + fetchMarketSize, marketsCount);
  }

  return await Promise.all(
    marketsIds.map(async (id) => await bondAggregatorGetMarketById(contracts, contractName, id))
  );
}

module.exports = {
  bondAggregatorGetMarketsCounter,
  bondAggregatorGetMarketById,
  bondAggregatorGetAllLiveMarketsIds,
  bondAggregatorGetAllLiveMarkets,
  bondAggregatorGetAllClosingMarketsIds,
  bondAggregatorGetAllClosingMarkets,
};
